// @flow
import GeoSearchControl from './GeoSearchControl'
import { createFormGroup } from '@src/components/ui/FormGroup'

export default createFormGroup(GeoSearchControl)
